import { gql } from "@apollo/client";

export const GET_BRAND_DETAILS = gql`
  query BrandDetails($brandId: Float!) {
    brandDetails(brandId: $brandId) {
      brandId
      brandKey
      brandName
      brandDisplayName
      brandDescription
      brandLogoUrl
      brandIsActive
      brandCreatedAt
      brandUpdatedAt
      brandDeletedAt
      brandCreatedBy
      brandUpdatedBy
      brandDeletedBy
      brandFeaturesCount
      brandPurchasersCount
      brandUsers {
        brandUserId
        brandUserName
        brandUserEmail
        brandAppUserId
        brandUserIsActive
        brandUserCreatedAt
        brandUserCreatedBy
        brandOrganizationUserId
        brandUserRoles {
          brandUserRoleId
          brandUserRoleAppId
          brandUserRoleKey
          brandUserRoleName
          brandUserRoleDescription
        }
      }
      brandFeatures {
        brandFeatureId
        brandFeatureKey
        brandFeatureName
        brandFeatureDescription
        brandFeatureIsActive
        brandFeatureIsMainMenu
        brandFeatureMappingId
        brandFeatureMappingCreatedAt
        brandFeatureMappingCreatedBy
      }
      brandPurchasers {
        purchaserId
        purchaserKey
        purchaserName
        purchaserIsActive
        brandPurchaser {
          id
          email
          isActive
          createdAt
          createdBy
          updatedAt
          updatedBy
          deletedAt
          deletedBy
        }
      }
    }
  }
`;
